export const toastDuration = 8000
